import { useCustom } from "@refinedev/core";
import { Flag } from "../components/types";

export const useAllFlags = () => {
  const { data: flags, isLoading } = useCustom<Flag[]>({
    url: "store/user-flags",
    method: "get",
    config: {
      query: {
        page: 0,
        size: 100,
      },
    },
  });
  return { flags, isLoading };
};
